import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref } from 'vue';
import { useTelegramStore } from '@/store';
import { useApplication } from '@/composables';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ApplicationTabs',
    emits: ['applicationSent'],
    setup: function (__props, _a) {
        var _this = this;
        var _b;
        var __emit = _a.emit;
        var telegramStore = useTelegramStore();
        var activeStage = ref('first');
        var sendApplication = useApplication().sendApplication;
        var applicationData = ref({
            firstname: '',
            lastname: '',
            surname: '',
            email: '',
            phone: '',
            city: '',
            about: '',
            telegram: (_b = telegramStore.telegramUser) === null || _b === void 0 ? void 0 : _b.id
        });
        var emit = __emit;
        var goToNextStage = function () { return __awaiter(_this, void 0, void 0, function () {
            var stages, currentIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        stages = ['first', 'second', 'third', 'fourth', 'fifth'];
                        currentIndex = stages.indexOf(activeStage.value);
                        if (!(currentIndex === stages.length - 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, sendApplication(applicationData.value)];
                    case 1:
                        _a.sent();
                        emit('applicationSent');
                        _a.label = 2;
                    case 2:
                        if (currentIndex < stages.length - 1) {
                            activeStage.value = stages[currentIndex + 1];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var filterPhoneInput = function (value) {
            applicationData.value.phone = value.replace(/\D/g, '');
        };
        return function (_ctx, _cache) {
            var _component_el_input = _resolveComponent("el-input");
            var _component_ApplicationTabContent = _resolveComponent("ApplicationTabContent");
            var _component_el_tab_pane = _resolveComponent("el-tab-pane");
            var _component_el_tabs = _resolveComponent("el-tabs");
            return (_openBlock(), _createBlock(_component_el_tabs, {
                modelValue: activeStage.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((activeStage).value = $event); }),
                class: "application-tabs",
                stretch: ""
            }, {
                default: _withCtx(function () { return [
                    _createVNode(_component_el_tab_pane, {
                        class: "application-tabs__tab",
                        name: "first",
                        disabled: activeStage.value !== 'first'
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_ApplicationTabContent, {
                                onNext: goToNextStage,
                                applicationData: applicationData.value,
                                requiredFields: ['firstname', 'lastname'],
                                questionText: "Ваше ФИО"
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_component_el_input, {
                                        class: "application-tabs__question-input",
                                        placeholder: "Фамилия",
                                        maxlength: "64",
                                        modelValue: applicationData.value.lastname,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((applicationData.value.lastname) = $event); })
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_el_input, {
                                        class: "application-tabs__question-input",
                                        placeholder: "Имя",
                                        maxlength: "64",
                                        modelValue: applicationData.value.firstname,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((applicationData.value.firstname) = $event); })
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_el_input, {
                                        class: "application-tabs__question-input",
                                        placeholder: "Отчество",
                                        maxlength: "64",
                                        modelValue: applicationData.value.surname,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((applicationData.value.surname) = $event); })
                                    }, null, 8, ["modelValue"])
                                ]; }),
                                _: 1
                            }, 8, ["applicationData"])
                        ]; }),
                        _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_tab_pane, {
                        class: "application-tabs__tab",
                        name: "second",
                        disabled: activeStage.value !== 'second'
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_ApplicationTabContent, {
                                onNext: goToNextStage,
                                applicationData: applicationData.value,
                                requiredFields: ['email'],
                                questionText: "Укажите Ваш e-mail"
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_component_el_input, {
                                        class: "application-tabs__question-input",
                                        placeholder: "E-mail",
                                        maxlength: "128",
                                        type: "email",
                                        modelValue: applicationData.value.email,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((applicationData.value.email) = $event); })
                                    }, null, 8, ["modelValue"])
                                ]; }),
                                _: 1
                            }, 8, ["applicationData"])
                        ]; }),
                        _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_tab_pane, {
                        class: "application-tabs__tab",
                        name: "third",
                        disabled: activeStage.value !== 'third'
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_ApplicationTabContent, {
                                onNext: goToNextStage,
                                applicationData: applicationData.value,
                                requiredFields: ['phone'],
                                questionText: "Номер телефона"
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_component_el_input, {
                                        class: "application-tabs__question-input",
                                        placeholder: "+7(999)999-99-99",
                                        maxlength: "64",
                                        type: "tel",
                                        modelValue: applicationData.value.phone,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((applicationData.value.phone) = $event); }),
                                        onInput: filterPhoneInput
                                    }, null, 8, ["modelValue"])
                                ]; }),
                                _: 1
                            }, 8, ["applicationData"])
                        ]; }),
                        _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_tab_pane, {
                        class: "application-tabs__tab",
                        name: "fourth",
                        disabled: activeStage.value !== 'fourth'
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_ApplicationTabContent, {
                                onNext: goToNextStage,
                                applicationData: applicationData.value,
                                requiredFields: ['city'],
                                questionText: "Город проживания"
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_component_el_input, {
                                        class: "application-tabs__question-input",
                                        placeholder: "г. Москва",
                                        maxlength: "128",
                                        modelValue: applicationData.value.city,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((applicationData.value.city) = $event); })
                                    }, null, 8, ["modelValue"])
                                ]; }),
                                _: 1
                            }, 8, ["applicationData"])
                        ]; }),
                        _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_tab_pane, {
                        class: "application-tabs__tab",
                        name: "fifth",
                        disabled: activeStage.value !== 'fifth'
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_ApplicationTabContent, {
                                onNext: goToNextStage,
                                applicationData: applicationData.value,
                                requiredFields: ['about'],
                                questionText: "Немного о себе"
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_component_el_input, {
                                        class: "application-tabs__question-input",
                                        placeholder: "Расскажите о себе",
                                        maxlength: "500",
                                        type: "textarea",
                                        modelValue: applicationData.value.about,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((applicationData.value.about) = $event); })
                                    }, null, 8, ["modelValue"])
                                ]; }),
                                _: 1
                            }, 8, ["applicationData"])
                        ]; }),
                        _: 1
                    }, 8, ["disabled"])
                ]; }),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
